import React from "react";
import {SearchResultTableWithUpdateUI} from "../../Common/SearchResultTableWithUpdateUI";
import {View} from "../Enum";
import {genGenPlateApiConst} from "../GenGenPlateApiConst";
import {GenGenPlateTableDataApi} from "../GenGenPlateTableDataApi";
import {GenGenPlateRawDataForm} from "./GenGenPlateRawDataForm";

interface GenGenPlateRawDataSearchResultTableProps {
    keywords: string
    comparator: string
    refreshToken: string
    view: View
}

interface GenGenPlateRawDataSearchResultTableState {}

export class GenGenPlateRawDataSearchResultTable extends React.Component<GenGenPlateRawDataSearchResultTableProps, GenGenPlateRawDataSearchResultTableState> {
    static defaultProps = {
        refreshToken: "",
        keywords: "",
    }

    render() {
        return <SearchResultTableWithUpdateUI
            refreshToken={this.props.refreshToken}
            databaseName={genGenPlateApiConst.DATABASE_NAME}
            tableName={genGenPlateApiConst.tableName.RAW_DATA}
            keywords={this.props.keywords}
            columns={""}
            operator={this.props.comparator}
            keyField={"id"}
            title={this.props.view === View.Update ? "" : "Gen Gen Raw Data"}
            legends={<></>}
            rowClasses={row => "table-light"}
            columnsHidden={["collectionRawData", "lastModified"]}
            columnsDisplayInOrder={["plateId", "owner"]}
            // These columns are not searchable because the way backend search data is following:
            // 1. Search for plateId in gen_gen_plate table that have keyword matching the selected columns
            // 2. Then use these plateID, it searches for raw data and plate map, then aggregate and return everything to front-end
            // 3. Thus, if selected columns exists in raw_data table but not in gen_gen_plate table, then it resulted in empty WHERE clause in SQL 
            // --> invalid syntax
            unsearchableColumns={["collectionDay", "collectionRound"]} 
            enableFilter={this.props.view === View.Update}
            view={this.props.view}
            modalClassName={"modal-larger-width"}
            modalForm={GenGenPlateRawDataForm}
            searchTable={GenGenPlateTableDataApi.searchTable}
        />
    }
}